import { render, staticRenderFns } from "./tbxz.vue?vue&type=template&id=3c30ac80&scoped=true&"
import script from "./tbxz.vue?vue&type=script&lang=js&"
export * from "./tbxz.vue?vue&type=script&lang=js&"
import style0 from "./tbxz.vue?vue&type=style&index=0&id=3c30ac80&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c30ac80",
  null
  
)

export default component.exports